import { productDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import getProp from "@insite/mobius/utilities/getProp";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import { css } from "styled-components";

Object.assign(productDescriptionStyles, {
    productDetailLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: {
            css: css`
                width: 100%;
                color: ${getProp("theme.typography.p.color")} !important;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                font-size: ${TYPOGRAPHY.size.large};
                line-height: 24px;
            `,
        },
    },
});
